import { IFilter } from "../models/filters/filter";
import { IReformFilter } from "../models/filters/reformFilter";
import _o2sService from "./_o2sServices";
import { IReformForm } from "../models/forms/reformForm";
import { IReformPDTO } from "../models/dtos/reformPDTO";
import { API_CENTRE } from "./config";

export default class ReformServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/reforms";

    protected static override getUrlFilter<F extends IReformFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null) 
        {
            if ( filter.centerId != null)
                url += `&CenterId=${filter.centerId}`;
            if ( filter.animalId != null)
                url += `&AnimalId=${filter.animalId}`;
            if ( filter.reasonId != null)
                url += `&ReasonId=${filter.reasonId}`;
            if ( filter.typeReformId != null)
                url += `&TypeReformId=${filter.typeReformId}`;
            if ( filter.state != null)
                url += `&State=${filter.state}`;
        }
        return url;
    }
    
    protected static override toDTO(obj:IReformForm):IReformPDTO {
        const dto = super.toDTO(obj) as IReformPDTO;
        
        return dto;
    }
}